var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgProfilesIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 110,
    height: 110,
    x: 0,
    y: 0,
    viewBox: "0 0 505.1 505.1",
    style: {
      enableBackground: "new 0 0 512 512"
    },
    xmlSpace: "preserve",
    className: "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    cx: 252.55,
    cy: 252.5,
    r: 252.5,
    fill: "#90dfaa",
    "data-original": "#90dfaa",
    className: ""
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M307.75,308.6c3.2,6.8,5.3,14,7.3,21.2c2.4,8.5,4.9,17,7.3,25.5c4.1,14.5,8.2,30.3,2.5,44.2  c-3.3,8-9.4,14.4-15.8,20.3c-7,6.4-14.4,12.4-22.2,17.9c-6.8,4.8-14,9.2-22,11.6c-8.6,2.5-17.7,2.5-26.7,2.3  c-5.8-0.1-11.8-0.3-17-2.9c-4.3-2.1-7.7-5.8-10.4-9.8c-9.9-14.8-10.2-33.8-10.2-51.6c0.1-27.3,0.2-54.6,0.2-82c0-5,0-10.1,1.3-15  c4-14.9,19.3-24.2,34.5-26.9c6-1.1,12.3-1.4,18.3-0.1c5.6,1.2,10.8,3.9,15.8,6.8C286.15,279.4,300.05,292.3,307.75,308.6z",
    fill: "#e6e9ee",
    "data-original": "#e6e9ee"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M252.55,177.9c-20.8,0-37.6,40.7-37.6,67.1c0,15.4,5.8,29.2,14.8,37.9c1.1-0.1,2.8-0.3,3.2-0.3  c1.7,0,3.6,0.2,5.2,0.7c1.6,0.5,3.3,1.1,4.8,1.9c0.3,0.2,1.3,0.8,2,1.3c0.3,0.1,0.6,0.3,1,0.5c1.1,0.5,2,1.1,3,1.8  c0.8,0.6,1.5,1.1,2.3,1.6c0.5,0.3,0.9,0.6,1.3,0.9h0.1c1-0.9,2.5-1.7,3.6-2.4c0.7-0.4,1.3-0.8,2.1-1.1c1-0.4,1.6-0.8,2.1-1  c0.4-0.8,4.9-2.3,5.2-2.4c2.7-0.9,5.2-0.7,8-0.3c0.1,0,0.2,0,0.3,0.1c9.9-8.6,16.4-23,16.4-39.3  C290.15,218.7,273.35,177.9,252.55,177.9z",
    fill: "#f9b54c",
    "data-original": "#f9b54c"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M142.35,471.1c0.5,2.9,0.8,5.9,1.1,9.2c-20.9-10-40.2-22.8-57.4-38c9.6-111.3,28.8-142.6,28.8-142.6  s0,0,0.1,0.2l37.7,61l-15.3,93.8c0,0,0,0,0,0.1C139.65,458.9,141.25,464.5,142.35,471.1z",
    fill: "#324a5e",
    "data-original": "#324a5e"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M262.45,504.8c-3.3,0.1-6.6,0.2-9.9,0.2c-3.3,0-6.6-0.1-9.9-0.2c-35-1.3-68.1-9.8-98-24  c-0.7-3.6-1.5-6.8-2.3-9.7c-2.5-9.5-4.7-15.6-5-16.4v-0.1c7.3-79.4-20.8-150.9-22.3-154.8c0-0.1-0.1-0.2-0.1-0.2  c7.9-9.2,44.9-18.2,68.4-23.2c11.6-2.4,20-3.9,20-3.9l-0.6,12.8l0.4,2.1l7.9,50.2c0,0,19.9,47.4,35.2,86.8c0,0.1,0.1,0.2,0.1,0.2  c2.2,5.9,4.4,11.6,6.4,17c0.2,0.5,0.3,1,0.5,1.5c0.7,2.1,1.5,4.2,2.2,6.2c0.2,0.6,0.4,1.1,0.6,1.7c0.4,1.2,0.9,2.4,1.2,3.6l0,0  c1.8,5.1,3,12.1,3.9,20.4c0.6,5.4,0.9,11.5,1.2,17.9C262.35,496.8,262.45,500.7,262.45,504.8z",
    fill: "#2b3b4e",
    "data-original": "#2b3b4e"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M211.65,251.6c0,0,26.4,170.1,45.5,203.1c0,0-55.3-32.2-77-136.4l16.3-5.6l-23.7-19.7  C172.75,293,185.15,266.3,211.65,251.6z",
    fill: "#324a5e",
    "data-original": "#324a5e"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M252.55,291.3c0,0-27.2-18.6-39.6,16.2c0,0-6.1-59.1,2.7-70C215.65,237.6,224.45,267.7,252.55,291.3z  ",
    fill: "#ffffff",
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M367.85,454.7L367.85,454.7l-15.3-93.9l37.7-61c0-0.1,0.1-0.2,0.1-0.2s19.2,31.3,28.8,142.6  c-17.2,15.1-36.5,27.9-57.4,38c0.3-3.2,0.6-6.3,1.1-9.2C363.85,464.5,365.45,458.9,367.85,454.7z",
    fill: "#2b3b4e",
    "data-original": "#2b3b4e"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M390.15,299.9c-1.5,3.9-29.6,75.4-22.3,154.8c0,0,0,0,0,0.1c-0.3,0.8-2.6,6.8-5,16.4  c-0.7,2.9-1.5,6.2-2.3,9.7c-29.9,14.2-63,22.6-98,24c-3.3,0.1-6.6,0.2-9.9,0.2c-3.3,0-6.6-0.1-9.9-0.2c0.2-21.3,1.7-39.7,5.3-50.1  l0,0c0.3-1,0.7-2,1.1-3c0.2-0.7,0.5-1.5,0.8-2.2c0.7-2,1.4-4,2.2-6.2c0.2-0.5,0.4-1,0.6-1.5c2-5.4,4.2-11.2,6.4-17.1c0,0,0,0,0-0.1  c15.2-39.5,35.2-86.8,35.2-86.8l6.5-41l1.8-11.3l-0.6-12.8c0,0,8.4,1.5,20.1,3.9c23.6,5,60.4,14,68.4,23.2  C390.25,299.7,390.25,299.8,390.15,299.9z",
    fill: "#324a5e",
    "data-original": "#324a5e"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M293.45,251.6c0,0-26.4,170.1-45.5,203.1c0,0,55.3-32.2,77-136.4l-16.3-5.6l23.7-19.7  C332.35,293,319.95,266.3,293.45,251.6z",
    fill: "#2b3b4e",
    "data-original": "#2b3b4e"
  }), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M252.55,291.3c0,0,27.2-18.6,39.6,16.2c0,0,6.1-59.1-2.7-70C289.45,237.6,280.65,267.7,252.55,291.3z  ",
    fill: "#ffffff",
    "data-original": "#ffffff"
  }), /*#__PURE__*/React.createElement("circle", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    cx: 265.55,
    cy: 483.8,
    r: 9.8,
    fill: "#2b3b4e",
    "data-original": "#2b3b4e"
  }), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M327.05,163.7c-5.1,12.6-17.6,25.9-25.4,23.6c-7.8-2.3-7.9-19.2-2.7-31.8   c5.1-12.6,13.6-16,21.3-13.8C328.05,144,332.25,151.1,327.05,163.7z",
    fill: "#f9b54c",
    "data-original": "#f9b54c"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M178.05,163.7c5.1,12.6,17.6,25.9,25.4,23.6c7.8-2.3,7.9-19.2,2.7-31.8c-5.1-12.6-13.6-16-21.3-13.8   C177.05,144,172.85,151.1,178.05,163.7z",
    fill: "#f9b54c",
    "data-original": "#f9b54c"
  })), /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {},
    cx: 252.55,
    cy: 164.3,
    rx: 60.6,
    ry: 78.5,
    fill: "#ffd05b",
    "data-original": "#ffd05b"
  }), /*#__PURE__*/React.createElement("path", {
    style: {},
    d: "M283.75,140.4l-11.7-47.2c0,0,15.4-18.4,19.6-17.8c4.1,0.6,27.5,25.4,27.5,25.4V136v14.5l-6.4,12.9   l-25.2-11L283.75,140.4z",
    fill: "#ffd05b",
    "data-original": "#ffd05b"
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {},
    points: "238.25,98.4 200.25,91.2 187.45,103.9 185.25,131.8 192.55,162.5 241.25,149.3  ",
    fill: "#ffd05b",
    "data-original": "#ffd05b"
  })), /*#__PURE__*/React.createElement("path", {
    xmlns: "http://www.w3.org/2000/svg",
    style: {},
    d: "M242.75,52.8c0,0,19.4-32.4,55.7,0c0,0-10-1.5-14.8,0c0,0,60.5,4.1,44.8,73.7c0,0,0.6,19.1-15.7,37  c0,0,18.8-79.9-30.6-60.5c0,0-32.1,18.1-55.1-0.8c0,0-44.2-12.8-34.5,60.2c0,0-51.4-92.4,5.4-104.1c0,0,14.8-32.1,69-23.7  C266.95,34.6,247.95,34.6,242.75,52.8z",
    fill: "#324a5e",
    "data-original": "#324a5e"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  })), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", {
    xmlns: "http://www.w3.org/2000/svg"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfilesIcon);
export default __webpack_public_path__ + "static/media/profiles-icon.b9d51fc7.svg";
export { ForwardRef as ReactComponent };